import { render, staticRenderFns } from "./mod5-5.vue?vue&type=template&id=2bf37a7b&scoped=true&"
import script from "./mod5-5.vue?vue&type=script&lang=js&"
export * from "./mod5-5.vue?vue&type=script&lang=js&"
import style0 from "./mod5-5.vue?vue&type=style&index=0&id=2bf37a7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf37a7b",
  null
  
)

export default component.exports